import type { SxProps } from "@mui/material";

export const boxStyle: SxProps = {
  display: "flex",
  mb: 2,
  justifyContent: "space-between",
  alignItems: "center",
};
